import http from './httpRequest.js'

export function getUserInfo() {
	return http({
		url: '/api/v1/customer/user_info',
		method: 'get'
	})
}

export function getStatistics() {
	return http({
		url: '/api/v1/customer/statistics',
		method: 'get'
	})
}

export function getStatisticsTrend() {
	return http({
		url: '/api/v1/customer/statistics/trend',
		method: 'get'
	})
}

export function getFriendList(params = {}) {
	console.log('[API] getFriendList 请求发送, params:', params);
	return http({
		url: '/api/v1/customer/friend_list',
		method: 'get',
		params: params
	}).then(res => {
		console.log('[API] getFriendList 响应:', JSON.stringify(res).substring(0, 500));
		return res;
	}).catch(err => {
		console.error('[API] getFriendList 失败:', err);
		throw err;
	})
}

export function getGroupList() {
	console.log('[API] getGroupList 请求发送');
	return http({
		url: '/api/v1/customer/group_list',
		method: 'get'
	}).then(res => {
		console.log('[API] getGroupList 响应:', JSON.stringify(res).substring(0, 500));
		return res;
	}).catch(err => {
		console.error('[API] getGroupList 失败:', err);
		throw err;
	})
}

// 群详情（群信息+成员列表），替代已废弃的 getGroupInfo/getGroupMembers
export function getGroupDetail(groupID) {
	return http({
		url: '/api/v1/customer/group_detail',
		method: 'get',
		params: { groupID }
	})
}

// --- 客户标签 ---

export function getContactTags() {
	return http({
		url: '/api/v1/customer/contact/tags',
		method: 'get'
	})
}

export function addContactTag(data) {
	return http({
		url: '/api/v1/customer/contact/tag/add',
		method: 'post',
		data: data
	})
}

export function removeContactTag(data) {
	return http({
		url: '/api/v1/customer/contact/tag/remove',
		method: 'post',
		data: data
	})
}

// --- 客户画像 ---

export function getContactProfile(params) {
	return http({
		url: '/api/v1/customer/contact/profile',
		method: 'get',
		params: params
	})
}

// --- 跟进提醒 ---

export function createReminder(data) {
	return http({
		url: '/api/v1/customer/reminder/create',
		method: 'post',
		data: data
	})
}

export function getReminderList() {
	return http({
		url: '/api/v1/customer/reminder/list',
		method: 'get'
	})
}

export function cancelReminder(data) {
	return http({
		url: '/api/v1/customer/reminder/cancel',
		method: 'post',
		data: data
	})
}

// --- 企微账号信息 ---

export function getAccountInfo(vid, cancelToken) {
	return http({
		url: '/api/v1/customer/account_info',
		method: 'get',
		params: { vid },
		cancelToken
	})
}

export function reAddFriend(data) {
	return http({
		url: '/api/v1/customer/re_add_friend',
		method: 'post',
		data: data
	})
}